import { Button, TextField, Typography, Divider } from "@mui/material"
import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Box from "elements/Box";
import { ProjectConfig } from 'Global';
import { useSnackbar, withSnackbar } from "notistack";

// Definición de los labels del sistema organizados por módulo
const SYSTEM_LABELS = {
  home: {
    title: "HOME",
    labels: [
      { key: "santo_del_dia", defaultValue: "Santo del día" },
      { key: "liturgia_horas", defaultValue: "Liturgia de las horas" },
      { key: "misa_del_dia", defaultValue: "Misa del día" },
      { key: "propios", defaultValue: "Comunes" },
      { key: "santoral", defaultValue: "Santoral" },
      { key: "calendario_liturgico", defaultValue: "Calendario litúrgico" },
      { key: "oraciones", defaultValue: "Oraciones" },
      { key: "celebraciones", defaultValue: "Celebraciones" },
      { key: "aniversarios", defaultValue: "Aniversarios" },
      { key: "maximas", defaultValue: "Máximas" },
      { key: "multimedia", defaultValue: "Multimedia" },
      { key: "constituciones", defaultValue: "Constituciones" },
      { key: "directorio", defaultValue: "Directorio" },
      { key: "acuerdos_capitulares", defaultValue: "Acuerdos capitulares" },
      { key: "ano_liturgico", defaultValue: "Año litúrgico" },
      { key: "cuenta", defaultValue: "Cuenta" },
      { key: "cerrar_sesion", defaultValue: "Cerrar sesión" },
    ]
  },
  santoral: {
    title: "SANTORAL",
    labels: [
      { key: "santoral_titulo", defaultValue: "Santoral" },
      { key: "santos_titulo", defaultValue: "Santos" },
      { key: "biografia", defaultValue: "BIOGRAFÍA" },
      { key: "oraciones_del_santo", defaultValue: "ORACIONES DEL SANTO" },
      { key: "calendario_propio_hsf", defaultValue: "CALENDARIO PROPIO HSF" },
      { key: "primeras_visperas", defaultValue: "PRIMERAS VÍSPERAS" },
      { key: "oficio_lectura", defaultValue: "OFICIO DE LECTURA" },
      { key: "laudes", defaultValue: "LAUDES" },
      { key: "horas_intermedias", defaultValue: "HORAS INTERMEDIAS" },
      { key: "visperas", defaultValue: "VÍSPERAS" },
      { key: "completas", defaultValue: "COMPLETAS" },
      { key: "lecturas", defaultValue: "LECTURAS DE LA MISA" },
    ]
  },
  aniversarios: {
    title: "ANIVERSARIOS",
    labels: [
      { key: "aniversarios_titulo", defaultValue: "Aniversarios" },
      { key: "nacimiento", defaultValue: "Nacimiento" },
      { key: "fallecimiento", defaultValue: "Fallecimiento" },
      { key: "ordenacion_sacerdotal", defaultValue: "Ordenación sacerdotal" },
      { key: "profesion_religiosa", defaultValue: "Profesión religiosa" },
      { key: "onomastica", defaultValue: "Onomástica" },
      { key: "biografia", defaultValue: "Biografía" },
      { key: "cumpleanos", defaultValue: "CUMPLEAÑOS" },
      { key: "profesion", defaultValue: "PROFESIÓN" },
      { key: "ordenacion", defaultValue: "ORDENACIÓN" },
      { key: "defuncion", defaultValue: "DEFUNCIÓN" },
    ]
  },
  fiestas: {
    title: "COMUNES",
    labels: [
      { key: "fiestas_titulo", defaultValue: "Comunes" },
      { key: "propios_titulo", defaultValue: "Comunes" },
      { key: "primeras_visperas", defaultValue: "PRIMERAS VÍSPERAS" },
      { key: "oficio_lectura", defaultValue: "OFICIO DE LECTURA" },
      { key: "laudes", defaultValue: "LAUDES" },
      { key: "horas_intermedias", defaultValue: "HORAS INTERMEDIAS" },
      { key: "visperas", defaultValue: "VÍSPERAS" },
      { key: "completas", defaultValue: "COMPLETAS" },
      { key: "lecturas", defaultValue: "LECTURAS DE LA MISA" },
      // Contenido estructurado de Comunes
      { key: "structured_option", defaultValue: "Opción" },
      { key: "structured_official_variants", defaultValue: "Variantes litúrgicas oficiales" },
      { key: "common_variant_default", defaultValue: "Texto general del común" },
      { key: "structured_mass", defaultValue: "Misa" },
      { key: "structured_entrance_antiphon", defaultValue: "Antífona de entrada" },
      { key: "structured_collect", defaultValue: "Oración colecta" },
      { key: "structured_prayer_over_offerings", defaultValue: "Oración sobre las ofrendas" },
      { key: "structured_preface", defaultValue: "Prefacio" },
      { key: "structured_communion_antiphon", defaultValue: "Antífona de comunión" },
      { key: "structured_prayer_after_communion", defaultValue: "Oración después de la comunión" },
      { key: "structured_lectionary", defaultValue: "Leccionario" },
      { key: "structured_first_reading", defaultValue: "Primera lectura" },
      { key: "structured_responsorial_psalm", defaultValue: "Salmo responsorial" },
      { key: "structured_second_reading", defaultValue: "Segunda lectura" },
      { key: "structured_gospel_acclamation", defaultValue: "Aclamación antes del Evangelio" },
      { key: "structured_gospel", defaultValue: "Evangelio" },
      { key: "structured_liturgy_of_hours", defaultValue: "Liturgia de las Horas" },
      { key: "structured_first_vespers", defaultValue: "Primeras vísperas" },
      { key: "structured_office_of_readings", defaultValue: "Oficio de lectura" },
      { key: "structured_lauds", defaultValue: "Laudes" },
      { key: "structured_midday_prayer", defaultValue: "Hora intermedia" },
      { key: "structured_vespers", defaultValue: "Vísperas" },
      { key: "common_variant_dedicated_church", defaultValue: "En la iglesia cuya dedicación se celebra" },
      { key: "common_variant_outside_dedicated_church", defaultValue: "Fuera de la iglesia dedicada" },
      { key: "common_variant_ordinary_time", defaultValue: "Tiempo Ordinario" },
      { key: "common_variant_advent", defaultValue: "Tiempo de Adviento" },
      { key: "common_variant_christmas", defaultValue: "Tiempo de Navidad" },
      { key: "common_variant_easter", defaultValue: "Tiempo Pascual" },
      { key: "common_variant_outside_easter_several_martyrs", defaultValue: "Fuera del tiempo pascual — Para varios mártires" },
      { key: "common_variant_outside_easter_one_martyr", defaultValue: "Fuera del tiempo pascual — Para un mártir" },
      { key: "common_variant_easter_several_martyrs", defaultValue: "Tiempo pascual — Para varios mártires" },
      { key: "common_variant_easter_one_martyr", defaultValue: "Tiempo pascual — Para un mártir" },
      { key: "common_variant_missionary_several_martyrs", defaultValue: "Para los misioneros mártires — Para varios misioneros mártires" },
      { key: "common_variant_missionary_one_martyr", defaultValue: "Para los misioneros mártires — Para un misionero mártir" },
      { key: "common_variant_virgin_martyr", defaultValue: "Para una virgen mártir" },
      { key: "common_variant_holy_woman_martyr", defaultValue: "Para una santa mujer mártir" },
      { key: "common_variant_pope_or_bishop", defaultValue: "Para un Papa o para un obispo" },
      { key: "common_variant_bishop", defaultValue: "Para un obispo" },
      { key: "common_variant_several_pastors", defaultValue: "Para los pastores — Para varios pastores" },
      { key: "common_variant_one_pastor", defaultValue: "Para los pastores — Para un pastor" },
      { key: "common_variant_one_founder", defaultValue: "Para los fundadores de las Iglesias — Para un fundador" },
      { key: "common_variant_several_founders", defaultValue: "Para los fundadores de las Iglesias — Para varios fundadores" },
      { key: "common_variant_missionaries", defaultValue: "Para los misioneros" },
      { key: "common_variant_several_virgins", defaultValue: "Para varias vírgenes" },
      { key: "common_variant_one_virgin", defaultValue: "Para una virgen" },
      { key: "common_variant_all_saints_several", defaultValue: "Para toda clase de santos — Para varios santos" },
      { key: "common_variant_all_saints_one", defaultValue: "Para toda clase de santos — Para un santo" },
      { key: "common_variant_abbot", defaultValue: "Para los monjes y los religiosos — Para un abad" },
      { key: "common_variant_monk", defaultValue: "Para los monjes y los religiosos — Para un monje" },
      { key: "common_variant_nun", defaultValue: "Para los monjes y los religiosos — Para una monja" },
      { key: "common_variant_religious", defaultValue: "Para los monjes y los religiosos — Para los religiosos" },
      { key: "common_variant_works_of_mercy", defaultValue: "Para los que hicieron obras de misericordia" },
      { key: "common_variant_educators", defaultValue: "Para los educadores" },
      { key: "common_variant_holy_women", defaultValue: "Para las santas mujeres" },
      { key: "common_variant_several_martyrs", defaultValue: "Para varios mártires" },
      { key: "common_variant_one_martyr", defaultValue: "Para un mártir" },
      { key: "common_variant_all_saints", defaultValue: "Para toda clase de santos" },
      { key: "common_variant_monks_religious", defaultValue: "Para los monjes y los religiosos" },
      { key: "common_family_dedication_church", defaultValue: "Común de la dedicación de una iglesia" },
      { key: "common_family_blessed_virgin_mary", defaultValue: "Común de santa María Virgen" },
      { key: "common_family_apostles", defaultValue: "Común de apóstoles" },
      { key: "common_family_martyrs", defaultValue: "Común de mártires" },
      { key: "common_family_pastors", defaultValue: "Común de pastores" },
      { key: "common_family_doctors", defaultValue: "Común de doctores de la Iglesia" },
      { key: "common_family_virgins", defaultValue: "Común de vírgenes" },
      { key: "common_family_holy_men_women", defaultValue: "Común de santos y santas" },
      { key: "common_filter_label", defaultValue: "Común" },
      { key: "common_content_unavailable", defaultValue: "Contenido no disponible en este idioma" },
    ]
  },
  maximas: {
    title: "MÁXIMAS",
    labels: [
      { key: "maximas_titulo", defaultValue: "Máximas" },
    ]
  },
  oraciones: {
    title: "ORACIONES",
    labels: [
      { key: "oraciones_titulo", defaultValue: "Oraciones" },
    ]
  },
  multimedia: {
    title: "MULTIMEDIA",
    labels: [
      { key: "multimedia_titulo", defaultValue: "Multimedia" },
      { key: "audios", defaultValue: "Audios" },
      { key: "videos", defaultValue: "Videos" },
    ]
  },
  acuerdos: {
    title: "ACUERDOS",
    labels: [
      { key: "acuerdos_titulo", defaultValue: "Acuerdos" },
    ]
  },
  directorio: {
    title: "DIRECTORIO",
    labels: [
      { key: "directorio_titulo", defaultValue: "Directorio" },
    ]
  },
  celebraciones: {
    title: "CELEBRACIONES",
    labels: [
      { key: "celebraciones_titulo", defaultValue: "Celebraciones" },
    ]
  },
  constituciones: {
    title: "CONSTITUCIONES",
    labels: [
      { key: "constituciones_titulo", defaultValue: "Constituciones" },
    ]
  },
  sistema: {
    title: "SISTEMA",
    labels: [
      { key: "atras", defaultValue: "Atrás" },
      { key: "hoy", defaultValue: "Hoy" },
      { key: "siguiente", defaultValue: "Siguiente" },
    ]
  },
  calendario_liturgico: {
    title: "CALENDARIO LITÚRGICO",
    labels: [
      { key: "calendario_liturgico_titulo", defaultValue: "Calendario litúrgico" },
      { key: "liturgia_horas_titulo", defaultValue: "Liturgia de las horas" },
      { key: "misa_del_dia_titulo", defaultValue: "Misa del día" },
      { key: "ir_a_lecturas", defaultValue: "Ir a lecturas" },
      // Secciones de la misa
      { key: "lectura", defaultValue: "Lectura" },
      { key: "lectio_divina", defaultValue: "Lectio divina" },
      { key: "reflexiones", defaultValue: "Reflexiones" },
      // Categorías
      { key: "oficio_lectura", defaultValue: "Oficio de lectura" },
      { key: "laudes", defaultValue: "Laudes" },
      { key: "horas_intermedias", defaultValue: "Horas intermedias" },
      { key: "visperas", defaultValue: "Vísperas" },
      { key: "completas", defaultValue: "Completas" },
      // Días de la semana
      { key: "domingo", defaultValue: "Domingo" },
      { key: "lunes", defaultValue: "Lunes" },
      { key: "martes", defaultValue: "Martes" },
      { key: "miercoles", defaultValue: "Miércoles" },
      { key: "jueves", defaultValue: "Jueves" },
      { key: "viernes", defaultValue: "Viernes" },
      { key: "sabado", defaultValue: "Sábado" },
      // Tiempos litúrgicos
      { key: "tiempo_ordinario", defaultValue: "Tiempo ordinario" },
      { key: "adviento", defaultValue: "Adviento" },
      { key: "navidad", defaultValue: "Navidad" },
      { key: "cuaresma", defaultValue: "Cuaresma" },
      { key: "semana_santa", defaultValue: "Semana Santa" },
      { key: "pascua", defaultValue: "Pascua" },
      // Meses del año
      { key: "enero", defaultValue: "Enero" },
      { key: "febrero", defaultValue: "Febrero" },
      { key: "marzo", defaultValue: "Marzo" },
      { key: "abril", defaultValue: "Abril" },
      { key: "mayo", defaultValue: "Mayo" },
      { key: "junio", defaultValue: "Junio" },
      { key: "julio", defaultValue: "Julio" },
      { key: "agosto", defaultValue: "Agosto" },
      { key: "septiembre", defaultValue: "Septiembre" },
      { key: "octubre", defaultValue: "Octubre" },
      { key: "noviembre", defaultValue: "Noviembre" },
      { key: "diciembre", defaultValue: "Diciembre" },
      // Otros
      { key: "semana", defaultValue: "Semana" },
      { key: "de", defaultValue: "de" },
      { key: "del", defaultValue: "del" },
      { key: "hoy", defaultValue: "Hoy" },
      { key: "fiesta_propia", defaultValue: "Fiesta propia" },
      // Colores litúrgicos
      { key: "color_blanco", defaultValue: "Blanco" },
      { key: "color_rojo", defaultValue: "Rojo" },
      { key: "color_verde", defaultValue: "Verde" },
      { key: "color_morado", defaultValue: "Morado" },
      { key: "color_rosa", defaultValue: "Rosa" },
      { key: "color_negro", defaultValue: "Negro" },
      { key: "color_dorado", defaultValue: "Dorado" },
    ]
  }
};

const COMMON_FIESTAS_LABELS_BY_LANG_ID: Record<string, Record<string, string>> = {
  "1": {
    "fiestas_titulo": "Comunes",
    "propios_titulo": "Comunes",
    "primeras_visperas": "PRIMERAS VÍSPERAS",
    "oficio_lectura": "OFICIO DE LECTURA",
    "laudes": "LAUDES",
    "horas_intermedias": "HORAS INTERMEDIAS",
    "visperas": "VÍSPERAS",
    "completas": "COMPLETAS",
    "lecturas": "LECTURAS DE LA MISA",
    "structured_option": "Opción",
    "structured_official_variants": "Variantes litúrgicas oficiales",
    "common_variant_default": "Texto general del común",
    "structured_mass": "Misa",
    "structured_entrance_antiphon": "Antífona de entrada",
    "structured_collect": "Oración colecta",
    "structured_prayer_over_offerings": "Oración sobre las ofrendas",
    "structured_preface": "Prefacio",
    "structured_communion_antiphon": "Antífona de comunión",
    "structured_prayer_after_communion": "Oración después de la comunión",
    "structured_lectionary": "Leccionario",
    "structured_first_reading": "Primera lectura",
    "structured_responsorial_psalm": "Salmo responsorial",
    "structured_second_reading": "Segunda lectura",
    "structured_gospel_acclamation": "Aclamación antes del Evangelio",
    "structured_gospel": "Evangelio",
    "structured_liturgy_of_hours": "Liturgia de las Horas",
    "structured_first_vespers": "Primeras Vísperas",
    "structured_office_of_readings": "Oficio de lectura",
    "structured_lauds": "Laudes",
    "structured_midday_prayer": "Hora intermedia",
    "structured_vespers": "Vísperas",
    "common_variant_dedicated_church": "En la iglesia cuya dedicación se celebra",
    "common_variant_outside_dedicated_church": "Fuera de la iglesia dedicada",
    "common_variant_ordinary_time": "Tiempo Ordinario",
    "common_variant_advent": "Tiempo de Adviento",
    "common_variant_christmas": "Tiempo de Navidad",
    "common_variant_easter": "Tiempo Pascual",
    "common_variant_outside_easter_several_martyrs": "Fuera del tiempo pascual — Para varios mártires",
    "common_variant_outside_easter_one_martyr": "Fuera del tiempo pascual — Para un mártir",
    "common_variant_easter_several_martyrs": "Tiempo pascual — Para varios mártires",
    "common_variant_easter_one_martyr": "Tiempo pascual — Para un mártir",
    "common_variant_missionary_several_martyrs": "Para los misioneros mártires — Para varios misioneros mártires",
    "common_variant_missionary_one_martyr": "Para los misioneros mártires — Para un misionero mártir",
    "common_variant_virgin_martyr": "Para una virgen mártir",
    "common_variant_holy_woman_martyr": "Para una santa mujer mártir",
    "common_variant_pope_or_bishop": "Para un Papa o para un obispo",
    "common_variant_bishop": "Para un obispo",
    "common_variant_several_pastors": "Para los pastores — Para varios pastores",
    "common_variant_one_pastor": "Para los pastores — Para un pastor",
    "common_variant_one_founder": "Para los fundadores de las Iglesias — Para un fundador",
    "common_variant_several_founders": "Para los fundadores de las Iglesias — Para varios fundadores",
    "common_variant_missionaries": "Para los misioneros",
    "common_variant_several_virgins": "Para varias vírgenes",
    "common_variant_one_virgin": "Para una virgen",
    "common_variant_all_saints_several": "Para toda clase de santos — Para varios santos",
    "common_variant_all_saints_one": "Para toda clase de santos — Para un santo",
    "common_variant_abbot": "Para los monjes y los religiosos — Para un abad",
    "common_variant_monk": "Para los monjes y los religiosos — Para un monje",
    "common_variant_nun": "Para los monjes y los religiosos — Para una monja",
    "common_variant_religious": "Para los monjes y los religiosos — Para los religiosos",
    "common_variant_works_of_mercy": "Para los que hicieron obras de misericordia",
    "common_variant_educators": "Para los educadores",
    "common_variant_holy_women": "Para las santas mujeres",
    "common_variant_several_martyrs": "Para varios mártires",
    "common_variant_one_martyr": "Para un mártir",
    "common_variant_all_saints": "Para toda clase de santos",
    "common_variant_monks_religious": "Para los monjes y los religiosos",
    "common_family_dedication_church": "Común de la dedicación de una iglesia",
    "common_family_blessed_virgin_mary": "Común de santa María Virgen",
    "common_family_apostles": "Común de apóstoles",
    "common_family_martyrs": "Común de mártires",
    "common_family_pastors": "Común de pastores",
    "common_family_doctors": "Común de doctores de la Iglesia",
    "common_family_virgins": "Común de vírgenes",
    "common_family_holy_men_women": "Común de santos y santas",
    "common_filter_label": "Común",
    "common_content_unavailable": "Contenido no disponible en este idioma"
  },
  "4": {
    "fiestas_titulo": "Commons",
    "propios_titulo": "Commons",
    "primeras_visperas": "First Vespers",
    "oficio_lectura": "Office of Readings",
    "laudes": "Lauds",
    "horas_intermedias": "Daytime Prayer",
    "visperas": "Vespers",
    "completas": "Compline",
    "lecturas": "MASS READINGS",
    "structured_option": "Option",
    "structured_official_variants": "Official liturgical variants",
    "common_variant_default": "General text of the Common",
    "structured_mass": "Mass",
    "structured_entrance_antiphon": "Entrance Antiphon",
    "structured_collect": "Collect",
    "structured_prayer_over_offerings": "Prayer over the Offerings",
    "structured_preface": "Preface",
    "structured_communion_antiphon": "Communion Antiphon",
    "structured_prayer_after_communion": "Prayer after Communion",
    "structured_lectionary": "Lectionary",
    "structured_first_reading": "First Reading",
    "structured_responsorial_psalm": "Responsorial Psalm",
    "structured_second_reading": "Second Reading",
    "structured_gospel_acclamation": "Gospel Acclamation",
    "structured_gospel": "Gospel",
    "structured_liturgy_of_hours": "Liturgy of the Hours",
    "structured_first_vespers": "First Vespers",
    "structured_office_of_readings": "Office of Readings",
    "structured_lauds": "Lauds",
    "structured_midday_prayer": "Daytime Prayer",
    "structured_vespers": "Vespers",
    "common_variant_dedicated_church": "In the church whose dedication is celebrated",
    "common_variant_outside_dedicated_church": "Outside the dedicated church",
    "common_variant_ordinary_time": "Ordinary Time",
    "common_variant_advent": "Advent",
    "common_variant_christmas": "Christmas",
    "common_variant_easter": "Easter Time",
    "common_variant_outside_easter_several_martyrs": "Outside Easter Time — For several martyrs",
    "common_variant_outside_easter_one_martyr": "Outside Easter Time — For one martyr",
    "common_variant_easter_several_martyrs": "Easter Time — For several martyrs",
    "common_variant_easter_one_martyr": "Easter Time — For one martyr",
    "common_variant_missionary_several_martyrs": "For missionary martyrs — For several missionary martyrs",
    "common_variant_missionary_one_martyr": "For missionary martyrs — For one missionary martyr",
    "common_variant_virgin_martyr": "For a virgin martyr",
    "common_variant_holy_woman_martyr": "For a holy woman martyr",
    "common_variant_pope_or_bishop": "For a Pope or a bishop",
    "common_variant_bishop": "For a bishop",
    "common_variant_several_pastors": "For pastors — For several pastors",
    "common_variant_one_pastor": "For pastors — For one pastor",
    "common_variant_one_founder": "For founders of Churches — For one founder",
    "common_variant_several_founders": "For founders of Churches — For several founders",
    "common_variant_missionaries": "For missionaries",
    "common_variant_several_virgins": "For several virgins",
    "common_variant_one_virgin": "For one virgin",
    "common_variant_all_saints_several": "For holy men and women — For several saints",
    "common_variant_all_saints_one": "For holy men and women — For one saint",
    "common_variant_abbot": "For monks and religious — For an abbot",
    "common_variant_monk": "For monks and religious — For a monk",
    "common_variant_nun": "For monks and religious — For a nun",
    "common_variant_religious": "For monks and religious — For religious",
    "common_variant_works_of_mercy": "For those who practiced works of mercy",
    "common_variant_educators": "For educators",
    "common_variant_holy_women": "For holy women",
    "common_variant_several_martyrs": "For several martyrs",
    "common_variant_one_martyr": "For one martyr",
    "common_variant_all_saints": "For holy men and women",
    "common_variant_monks_religious": "For monks and religious",
    "common_family_dedication_church": "Common of the Dedication of a Church",
    "common_family_blessed_virgin_mary": "Common of the Blessed Virgin Mary",
    "common_family_apostles": "Common of Apostles",
    "common_family_martyrs": "Common of Martyrs",
    "common_family_pastors": "Common of Pastors",
    "common_family_doctors": "Common of Doctors of the Church",
    "common_family_virgins": "Common of Virgins",
    "common_family_holy_men_women": "Common of Holy Men and Women",
    "common_filter_label": "Common",
    "common_content_unavailable": "Content is not available in this language"
  },
  "5": {
    "fiestas_titulo": "Comuni",
    "propios_titulo": "Comuni",
    "primeras_visperas": "Primi Vespri",
    "oficio_lectura": "Ufficio delle letture",
    "laudes": "Lodi mattutine",
    "horas_intermedias": "Ora media",
    "visperas": "Vespri",
    "completas": "Compieta",
    "lecturas": "LETTURE DELLA MESSA",
    "structured_option": "Opzione",
    "structured_official_variants": "Varianti liturgiche ufficiali",
    "common_variant_default": "Testo generale del Comune",
    "structured_mass": "Messa",
    "structured_entrance_antiphon": "Antifona d'ingresso",
    "structured_collect": "Colletta",
    "structured_prayer_over_offerings": "Preghiera sulle offerte",
    "structured_preface": "Prefazio",
    "structured_communion_antiphon": "Antifona alla comunione",
    "structured_prayer_after_communion": "Preghiera dopo la comunione",
    "structured_lectionary": "Lezionario",
    "structured_first_reading": "Prima lettura",
    "structured_responsorial_psalm": "Salmo responsoriale",
    "structured_second_reading": "Seconda lettura",
    "structured_gospel_acclamation": "Acclamazione al Vangelo",
    "structured_gospel": "Vangelo",
    "structured_liturgy_of_hours": "Liturgia delle Ore",
    "structured_first_vespers": "Primi Vespri",
    "structured_office_of_readings": "Ufficio delle letture",
    "structured_lauds": "Lodi mattutine",
    "structured_midday_prayer": "Ora media",
    "structured_vespers": "Vespri",
    "common_variant_dedicated_church": "Nella chiesa di cui si celebra la dedicazione",
    "common_variant_outside_dedicated_church": "Fuori della chiesa dedicata",
    "common_variant_ordinary_time": "Tempo Ordinario",
    "common_variant_advent": "Tempo di Avvento",
    "common_variant_christmas": "Tempo di Natale",
    "common_variant_easter": "Tempo Pasquale",
    "common_variant_outside_easter_several_martyrs": "Fuori del Tempo Pasquale — Per più martiri",
    "common_variant_outside_easter_one_martyr": "Fuori del Tempo Pasquale — Per un martire",
    "common_variant_easter_several_martyrs": "Tempo Pasquale — Per più martiri",
    "common_variant_easter_one_martyr": "Tempo Pasquale — Per un martire",
    "common_variant_missionary_several_martyrs": "Per i missionari martiri — Per più missionari martiri",
    "common_variant_missionary_one_martyr": "Per i missionari martiri — Per un missionario martire",
    "common_variant_virgin_martyr": "Per una vergine martire",
    "common_variant_holy_woman_martyr": "Per una santa donna martire",
    "common_variant_pope_or_bishop": "Per un Papa o un vescovo",
    "common_variant_bishop": "Per un vescovo",
    "common_variant_several_pastors": "Per i pastori — Per più pastori",
    "common_variant_one_pastor": "Per i pastori — Per un pastore",
    "common_variant_one_founder": "Per i fondatori delle Chiese — Per un fondatore",
    "common_variant_several_founders": "Per i fondatori delle Chiese — Per più fondatori",
    "common_variant_missionaries": "Per i missionari",
    "common_variant_several_virgins": "Per più vergini",
    "common_variant_one_virgin": "Per una vergine",
    "common_variant_all_saints_several": "Per i santi e le sante — Per più santi",
    "common_variant_all_saints_one": "Per i santi e le sante — Per un santo",
    "common_variant_abbot": "Per i monaci e i religiosi — Per un abate",
    "common_variant_monk": "Per i monaci e i religiosi — Per un monaco",
    "common_variant_nun": "Per i monaci e i religiosi — Per una monaca",
    "common_variant_religious": "Per i monaci e i religiosi — Per i religiosi",
    "common_variant_works_of_mercy": "Per coloro che hanno esercitato opere di misericordia",
    "common_variant_educators": "Per gli educatori",
    "common_variant_holy_women": "Per le sante donne",
    "common_variant_several_martyrs": "Per più martiri",
    "common_variant_one_martyr": "Per un martire",
    "common_variant_all_saints": "Per i santi e le sante",
    "common_variant_monks_religious": "Per i monaci e i religiosi",
    "common_family_dedication_church": "Comune della dedicazione di una chiesa",
    "common_family_blessed_virgin_mary": "Comune della beata Vergine Maria",
    "common_family_apostles": "Comune degli apostoli",
    "common_family_martyrs": "Comune dei martiri",
    "common_family_pastors": "Comune dei pastori",
    "common_family_doctors": "Comune dei dottori della Chiesa",
    "common_family_virgins": "Comune delle vergini",
    "common_family_holy_men_women": "Comune dei santi e delle sante",
    "common_filter_label": "Comune",
    "common_content_unavailable": "Contenuto non disponibile in questa lingua"
  },
  "6": {
    "fiestas_titulo": "Comuns",
    "propios_titulo": "Comuns",
    "primeras_visperas": "Primeiras Vésperas",
    "oficio_lectura": "Ofício das Leituras",
    "laudes": "Laudes",
    "horas_intermedias": "Hora Intermédia",
    "visperas": "Vésperas",
    "completas": "Completas",
    "lecturas": "LEITURAS DA MISSA",
    "structured_option": "Opção",
    "structured_official_variants": "Variantes litúrgicas oficiais",
    "common_variant_default": "Texto geral do Comum",
    "structured_mass": "Missa",
    "structured_entrance_antiphon": "Antífona de entrada",
    "structured_collect": "Oração coleta",
    "structured_prayer_over_offerings": "Oração sobre as oferendas",
    "structured_preface": "Prefácio",
    "structured_communion_antiphon": "Antífona da comunhão",
    "structured_prayer_after_communion": "Oração depois da comunhão",
    "structured_lectionary": "Lecionário",
    "structured_first_reading": "Primeira leitura",
    "structured_responsorial_psalm": "Salmo responsorial",
    "structured_second_reading": "Segunda leitura",
    "structured_gospel_acclamation": "Aclamação ao Evangelho",
    "structured_gospel": "Evangelho",
    "structured_liturgy_of_hours": "Liturgia das Horas",
    "structured_first_vespers": "Primeiras Vésperas",
    "structured_office_of_readings": "Ofício das Leituras",
    "structured_lauds": "Laudes",
    "structured_midday_prayer": "Hora intermédia",
    "structured_vespers": "Vésperas",
    "common_variant_dedicated_church": "Na igreja cuja dedicação se celebra",
    "common_variant_outside_dedicated_church": "Fora da igreja dedicada",
    "common_variant_ordinary_time": "Tempo Comum",
    "common_variant_advent": "Tempo do Advento",
    "common_variant_christmas": "Tempo do Natal",
    "common_variant_easter": "Tempo Pascal",
    "common_variant_outside_easter_several_martyrs": "Fora do Tempo Pascal — Para vários mártires",
    "common_variant_outside_easter_one_martyr": "Fora do Tempo Pascal — Para um mártir",
    "common_variant_easter_several_martyrs": "Tempo Pascal — Para vários mártires",
    "common_variant_easter_one_martyr": "Tempo Pascal — Para um mártir",
    "common_variant_missionary_several_martyrs": "Para os missionários mártires — Para vários missionários mártires",
    "common_variant_missionary_one_martyr": "Para os missionários mártires — Para um missionário mártir",
    "common_variant_virgin_martyr": "Para uma virgem mártir",
    "common_variant_holy_woman_martyr": "Para uma santa mulher mártir",
    "common_variant_pope_or_bishop": "Para um Papa ou um bispo",
    "common_variant_bishop": "Para um bispo",
    "common_variant_several_pastors": "Para os pastores — Para vários pastores",
    "common_variant_one_pastor": "Para os pastores — Para um pastor",
    "common_variant_one_founder": "Para os fundadores das Igrejas — Para um fundador",
    "common_variant_several_founders": "Para os fundadores das Igrejas — Para vários fundadores",
    "common_variant_missionaries": "Para os missionários",
    "common_variant_several_virgins": "Para várias virgens",
    "common_variant_one_virgin": "Para uma virgem",
    "common_variant_all_saints_several": "Para santos e santas — Para vários santos",
    "common_variant_all_saints_one": "Para santos e santas — Para um santo",
    "common_variant_abbot": "Para os monges e religiosos — Para um abade",
    "common_variant_monk": "Para os monges e religiosos — Para um monge",
    "common_variant_nun": "Para os monges e religiosos — Para uma monja",
    "common_variant_religious": "Para os monges e religiosos — Para os religiosos",
    "common_variant_works_of_mercy": "Para os que praticaram obras de misericórdia",
    "common_variant_educators": "Para os educadores",
    "common_variant_holy_women": "Para as santas mulheres",
    "common_variant_several_martyrs": "Para vários mártires",
    "common_variant_one_martyr": "Para um mártir",
    "common_variant_all_saints": "Para santos e santas",
    "common_variant_monks_religious": "Para os monges e religiosos",
    "common_family_dedication_church": "Comum da dedicação de uma igreja",
    "common_family_blessed_virgin_mary": "Comum da Bem-aventurada Virgem Maria",
    "common_family_apostles": "Comum dos Apóstolos",
    "common_family_martyrs": "Comum dos Mártires",
    "common_family_pastors": "Comum dos Pastores",
    "common_family_doctors": "Comum dos Doutores da Igreja",
    "common_family_virgins": "Comum das Virgens",
    "common_family_holy_men_women": "Comum dos Santos e Santas",
    "common_filter_label": "Comum",
    "common_content_unavailable": "Conteúdo não disponível neste idioma"
  },
  "7": {
    "fiestas_titulo": "Communs",
    "propios_titulo": "Communs",
    "primeras_visperas": "Premières vêpres",
    "oficio_lectura": "Office des lectures",
    "laudes": "Laudes",
    "horas_intermedias": "Heure médiane",
    "visperas": "Vêpres",
    "completas": "Complies",
    "lecturas": "LECTURES DE LA MESSE",
    "structured_option": "Option",
    "structured_official_variants": "Variantes liturgiques officielles",
    "common_variant_default": "Texte général du Commun",
    "structured_mass": "Messe",
    "structured_entrance_antiphon": "Antienne d'ouverture",
    "structured_collect": "Prière d'ouverture",
    "structured_prayer_over_offerings": "Prière sur les offrandes",
    "structured_preface": "Préface",
    "structured_communion_antiphon": "Antienne de la communion",
    "structured_prayer_after_communion": "Prière après la communion",
    "structured_lectionary": "Lectionnaire",
    "structured_first_reading": "Première lecture",
    "structured_responsorial_psalm": "Psaume responsorial",
    "structured_second_reading": "Deuxième lecture",
    "structured_gospel_acclamation": "Acclamation de l'Évangile",
    "structured_gospel": "Évangile",
    "structured_liturgy_of_hours": "Liturgie des Heures",
    "structured_first_vespers": "Premières vêpres",
    "structured_office_of_readings": "Office des lectures",
    "structured_lauds": "Laudes",
    "structured_midday_prayer": "Heure médiane",
    "structured_vespers": "Vêpres",
    "common_variant_dedicated_church": "Dans l'église dont on célèbre la dédicace",
    "common_variant_outside_dedicated_church": "En dehors de l'église dédiée",
    "common_variant_ordinary_time": "Temps ordinaire",
    "common_variant_advent": "Temps de l'Avent",
    "common_variant_christmas": "Temps de Noël",
    "common_variant_easter": "Temps pascal",
    "common_variant_outside_easter_several_martyrs": "Hors du temps pascal — Pour plusieurs martyrs",
    "common_variant_outside_easter_one_martyr": "Hors du temps pascal — Pour un martyr",
    "common_variant_easter_several_martyrs": "Temps pascal — Pour plusieurs martyrs",
    "common_variant_easter_one_martyr": "Temps pascal — Pour un martyr",
    "common_variant_missionary_several_martyrs": "Pour les missionnaires martyrs — Pour plusieurs missionnaires martyrs",
    "common_variant_missionary_one_martyr": "Pour les missionnaires martyrs — Pour un missionnaire martyr",
    "common_variant_virgin_martyr": "Pour une vierge martyre",
    "common_variant_holy_woman_martyr": "Pour une sainte femme martyre",
    "common_variant_pope_or_bishop": "Pour un Pape ou un évêque",
    "common_variant_bishop": "Pour un évêque",
    "common_variant_several_pastors": "Pour les pasteurs — Pour plusieurs pasteurs",
    "common_variant_one_pastor": "Pour les pasteurs — Pour un pasteur",
    "common_variant_one_founder": "Pour les fondateurs des Églises — Pour un fondateur",
    "common_variant_several_founders": "Pour les fondateurs des Églises — Pour plusieurs fondateurs",
    "common_variant_missionaries": "Pour les missionnaires",
    "common_variant_several_virgins": "Pour plusieurs vierges",
    "common_variant_one_virgin": "Pour une vierge",
    "common_variant_all_saints_several": "Pour les saints et saintes — Pour plusieurs saints",
    "common_variant_all_saints_one": "Pour les saints et saintes — Pour un saint",
    "common_variant_abbot": "Pour les moines et les religieux — Pour un abbé",
    "common_variant_monk": "Pour les moines et les religieux — Pour un moine",
    "common_variant_nun": "Pour les moines et les religieux — Pour une moniale",
    "common_variant_religious": "Pour les moines et les religieux — Pour les religieux",
    "common_variant_works_of_mercy": "Pour ceux qui ont pratiqué les œuvres de miséricorde",
    "common_variant_educators": "Pour les éducateurs",
    "common_variant_holy_women": "Pour les saintes femmes",
    "common_variant_several_martyrs": "Pour plusieurs martyrs",
    "common_variant_one_martyr": "Pour un martyr",
    "common_variant_all_saints": "Pour les saints et saintes",
    "common_variant_monks_religious": "Pour les moines et les religieux",
    "common_family_dedication_church": "Commun de la dédicace d'une église",
    "common_family_blessed_virgin_mary": "Commun de la bienheureuse Vierge Marie",
    "common_family_apostles": "Commun des Apôtres",
    "common_family_martyrs": "Commun des Martyrs",
    "common_family_pastors": "Commun des Pasteurs",
    "common_family_doctors": "Commun des Docteurs de l'Église",
    "common_family_virgins": "Commun des Vierges",
    "common_family_holy_men_women": "Commun des Saints et Saintes",
    "common_filter_label": "Commun",
    "common_content_unavailable": "Contenu non disponible dans cette langue"
  },
  "9": {
    "fiestas_titulo": "Comuns",
    "propios_titulo": "Comuns",
    "primeras_visperas": "Primeres vespres",
    "oficio_lectura": "Ofici de lectura",
    "laudes": "Laudes",
    "horas_intermedias": "Hora intermèdia",
    "visperas": "Vespres",
    "completas": "Completes",
    "lecturas": "LECTURES DE LA MISSA",
    "structured_option": "Opció",
    "structured_official_variants": "Variants litúrgiques oficials",
    "common_variant_default": "Text general del Comú",
    "structured_mass": "Missa",
    "structured_entrance_antiphon": "Antífona d'entrada",
    "structured_collect": "Oració col·lecta",
    "structured_prayer_over_offerings": "Oració sobre les ofrenes",
    "structured_preface": "Prefaci",
    "structured_communion_antiphon": "Antífona de comunió",
    "structured_prayer_after_communion": "Oració després de la comunió",
    "structured_lectionary": "Leccionari",
    "structured_first_reading": "Primera lectura",
    "structured_responsorial_psalm": "Salm responsorial",
    "structured_second_reading": "Segona lectura",
    "structured_gospel_acclamation": "Aclamació abans de l'Evangeli",
    "structured_gospel": "Evangeli",
    "structured_liturgy_of_hours": "Litúrgia de les Hores",
    "structured_first_vespers": "Primeres vespres",
    "structured_office_of_readings": "Ofici de lectura",
    "structured_lauds": "Laudes",
    "structured_midday_prayer": "Hora intermèdia",
    "structured_vespers": "Vespres",
    "common_variant_dedicated_church": "A l'església de la qual se celebra la dedicació",
    "common_variant_outside_dedicated_church": "Fora de l'església dedicada",
    "common_variant_ordinary_time": "Temps de durant l'any",
    "common_variant_advent": "Temps d'Advent",
    "common_variant_christmas": "Temps de Nadal",
    "common_variant_easter": "Temps pasqual",
    "common_variant_outside_easter_several_martyrs": "Fora del temps pasqual — Per a diversos màrtirs",
    "common_variant_outside_easter_one_martyr": "Fora del temps pasqual — Per a un màrtir",
    "common_variant_easter_several_martyrs": "Temps pasqual — Per a diversos màrtirs",
    "common_variant_easter_one_martyr": "Temps pasqual — Per a un màrtir",
    "common_variant_missionary_several_martyrs": "Per als missioners màrtirs — Per a diversos missioners màrtirs",
    "common_variant_missionary_one_martyr": "Per als missioners màrtirs — Per a un missioner màrtir",
    "common_variant_virgin_martyr": "Per a una verge màrtir",
    "common_variant_holy_woman_martyr": "Per a una dona santa màrtir",
    "common_variant_pope_or_bishop": "Per a un Papa o un bisbe",
    "common_variant_bishop": "Per a un bisbe",
    "common_variant_several_pastors": "Per als pastors — Per a diversos pastors",
    "common_variant_one_pastor": "Per als pastors — Per a un pastor",
    "common_variant_one_founder": "Per als fundadors de les Esglésies — Per a un fundador",
    "common_variant_several_founders": "Per als fundadors de les Esglésies — Per a diversos fundadors",
    "common_variant_missionaries": "Per als missioners",
    "common_variant_several_virgins": "Per a diverses verges",
    "common_variant_one_virgin": "Per a una verge",
    "common_variant_all_saints_several": "Per a tota mena de sants — Per a diversos sants",
    "common_variant_all_saints_one": "Per a tota mena de sants — Per a un sant",
    "common_variant_abbot": "Per als monjos i religiosos — Per a un abat",
    "common_variant_monk": "Per als monjos i religiosos — Per a un monjo",
    "common_variant_nun": "Per als monjos i religiosos — Per a una monja",
    "common_variant_religious": "Per als monjos i religiosos — Per als religiosos",
    "common_variant_works_of_mercy": "Per als qui han practicat obres de misericòrdia",
    "common_variant_educators": "Per als educadors",
    "common_variant_holy_women": "Per a les dones santes",
    "common_variant_several_martyrs": "Per a diversos màrtirs",
    "common_variant_one_martyr": "Per a un màrtir",
    "common_variant_all_saints": "Per a tota mena de sants",
    "common_variant_monks_religious": "Per als monjos i religiosos",
    "common_family_dedication_church": "Comú de la dedicació d'una església",
    "common_family_blessed_virgin_mary": "Comú de santa Maria Verge",
    "common_family_apostles": "Comú dels apòstols",
    "common_family_martyrs": "Comú dels màrtirs",
    "common_family_pastors": "Comú dels pastors",
    "common_family_doctors": "Comú dels doctors de l'Església",
    "common_family_virgins": "Comú de verges",
    "common_family_holy_men_women": "Comú de sants i santes",
    "common_filter_label": "Comú",
    "common_content_unavailable": "Contingut no disponible en aquesta llengua"
  },
  "10": {
    "fiestas_titulo": "Communia",
    "propios_titulo": "Communia",
    "primeras_visperas": "I Vesperae",
    "oficio_lectura": "Officium lectionis",
    "laudes": "Laudes matutinae",
    "horas_intermedias": "Hora media",
    "visperas": "Vesperae",
    "completas": "Completorium",
    "lecturas": "LECTIONES MISSAE",
    "structured_option": "Optio",
    "structured_official_variants": "Variationes liturgicae officiales",
    "common_variant_default": "Textus generalis Communis",
    "structured_mass": "Missa",
    "structured_entrance_antiphon": "Antiphona ad introitum",
    "structured_collect": "Collecta",
    "structured_prayer_over_offerings": "Super oblata",
    "structured_preface": "Praefatio",
    "structured_communion_antiphon": "Antiphona ad communionem",
    "structured_prayer_after_communion": "Post communionem",
    "structured_lectionary": "Lectionarium",
    "structured_first_reading": "Lectio prima",
    "structured_responsorial_psalm": "Psalmus responsorius",
    "structured_second_reading": "Lectio secunda",
    "structured_gospel_acclamation": "Acclamatio ante Evangelium",
    "structured_gospel": "Evangelium",
    "structured_liturgy_of_hours": "Liturgia Horarum",
    "structured_first_vespers": "I Vesperae",
    "structured_office_of_readings": "Officium lectionis",
    "structured_lauds": "Laudes matutinae",
    "structured_midday_prayer": "Hora media",
    "structured_vespers": "Vesperae",
    "common_variant_dedicated_church": "In ecclesia cuius dedicatio celebratur",
    "common_variant_outside_dedicated_church": "Extra ecclesiam dedicatam",
    "common_variant_ordinary_time": "Tempus per annum",
    "common_variant_advent": "Tempus Adventus",
    "common_variant_christmas": "Tempus Nativitatis",
    "common_variant_easter": "Tempus paschale",
    "common_variant_outside_easter_several_martyrs": "Extra tempus paschale — Pro pluribus martyribus",
    "common_variant_outside_easter_one_martyr": "Extra tempus paschale — Pro uno martyre",
    "common_variant_easter_several_martyrs": "Tempus paschale — Pro pluribus martyribus",
    "common_variant_easter_one_martyr": "Tempus paschale — Pro uno martyre",
    "common_variant_missionary_several_martyrs": "Pro missionariis martyribus — Pro pluribus missionariis martyribus",
    "common_variant_missionary_one_martyr": "Pro missionariis martyribus — Pro uno missionario martyre",
    "common_variant_virgin_martyr": "Pro virgine martyre",
    "common_variant_holy_woman_martyr": "Pro sancta muliere martyre",
    "common_variant_pope_or_bishop": "Pro Papa vel Episcopo",
    "common_variant_bishop": "Pro Episcopo",
    "common_variant_several_pastors": "Pro pastoribus — Pro pluribus pastoribus",
    "common_variant_one_pastor": "Pro pastoribus — Pro uno pastore",
    "common_variant_one_founder": "Pro fundatoribus Ecclesiarum — Pro uno fundatore",
    "common_variant_several_founders": "Pro fundatoribus Ecclesiarum — Pro pluribus fundatoribus",
    "common_variant_missionaries": "Pro missionariis",
    "common_variant_several_virgins": "Pro pluribus virginibus",
    "common_variant_one_virgin": "Pro una virgine",
    "common_variant_all_saints_several": "Pro omnibus sanctis — Pro pluribus sanctis",
    "common_variant_all_saints_one": "Pro omnibus sanctis — Pro uno sancto",
    "common_variant_abbot": "Pro monachis et religiosis — Pro abbate",
    "common_variant_monk": "Pro monachis et religiosis — Pro monacho",
    "common_variant_nun": "Pro monachis et religiosis — Pro moniali",
    "common_variant_religious": "Pro monachis et religiosis — Pro religiosis",
    "common_variant_works_of_mercy": "Pro iis qui opera misericordiae exercuerunt",
    "common_variant_educators": "Pro educatoribus",
    "common_variant_holy_women": "Pro sanctis mulieribus",
    "common_variant_several_martyrs": "Pro pluribus martyribus",
    "common_variant_one_martyr": "Pro uno martyre",
    "common_variant_all_saints": "Pro omnibus sanctis",
    "common_variant_monks_religious": "Pro monachis et religiosis",
    "common_family_dedication_church": "Commune Dedicationis ecclesiae",
    "common_family_blessed_virgin_mary": "Commune beatae Mariae Virginis",
    "common_family_apostles": "Commune Apostolorum",
    "common_family_martyrs": "Commune Martyrum",
    "common_family_pastors": "Commune Pastorum",
    "common_family_doctors": "Commune Doctorum Ecclesiae",
    "common_family_virgins": "Commune Virginum",
    "common_family_holy_men_women": "Commune Sanctorum et Sanctarum",
    "common_filter_label": "Commune",
    "common_content_unavailable": "Textus hoc sermone nondum adest"
  }
};

const LEGACY_COMMON_LABELS_BY_LANG_ID: Record<string, string[]> = {
  "1": ["Propios"],
  "4": ["Proper", "Propers", "Proper Texts"],
  "5": ["Propri", "Testi propri"],
  "6": ["Próprios", "Proprios", "Textos próprios", "Textos proprios"],
  "7": ["Propres", "Textes propres"],
  "9": ["Propis", "Textos propis"],
  "10": ["Propria", "Textus proprii"],
};

const isLegacyCommonLabel = (
  value: string | undefined,
  langId: string
): boolean => {
  if (!value) {
    return false;
  }

  const normalizedValue = String(value).trim().toLocaleLowerCase();
  return (LEGACY_COMMON_LABELS_BY_LANG_ID[langId] || []).some(
    legacyValue => legacyValue.toLocaleLowerCase() === normalizedValue
  );
};

const applyCanonicalCommonLabels = (
  labels: Record<string, Record<string, string>> | null | undefined,
  langId: string | number | undefined
): Record<string, Record<string, string>> => {
  const baseLabels = labels || {};
  const normalizedLangId = String(langId ?? '');
  const canonicalFiestas = COMMON_FIESTAS_LABELS_BY_LANG_ID[normalizedLangId];

  if (!canonicalFiestas) {
    return baseLabels;
  }

  const spanishFiestas = COMMON_FIESTAS_LABELS_BY_LANG_ID['1'] || {};
  const existingFiestas = baseLabels.fiestas || {};
  const mergedFiestas: Record<string, string> = {
    ...existingFiestas,
  };

  Object.entries(canonicalFiestas).forEach(([key, translatedValue]) => {
    const currentValue = existingFiestas[key];
    const spanishValue = spanishFiestas[key];

    if (
      !currentValue
      || String(currentValue).trim() === ''
      || ((key === 'fiestas_titulo' || key === 'propios_titulo')
        && isLegacyCommonLabel(currentValue, normalizedLangId))
      || (normalizedLangId !== '1' && currentValue === spanishValue)
    ) {
      mergedFiestas[key] = translatedValue;
    }
  });

  const existingHome = baseLabels.home || {};
  const mergedHome: Record<string, string> = {
    ...existingHome,
  };
  const currentHomeCommon = existingHome.propios;
  const spanishHomeCommon = spanishFiestas.propios_titulo;

  if (
    !currentHomeCommon
    || String(currentHomeCommon).trim() === ''
    || isLegacyCommonLabel(currentHomeCommon, normalizedLangId)
    || (normalizedLangId !== '1' && currentHomeCommon === spanishHomeCommon)
  ) {
    mergedHome.propios = canonicalFiestas.propios_titulo;
  }

  return {
    ...baseLabels,
    home: mergedHome,
    fiestas: mergedFiestas,
  };
};

export default withSnackbar(
  function LangEditor(props: any) {

  /*SNACKBAR FUNCTION FOR NOTIFICATIONS*/
  const { enqueueSnackbar } = useSnackbar();
  /*============================================= */

  /*=======================================
    GET LANG ID FROM URL
  =======================================*/
  let { lang_id } = useParams();
  /*=======================================
  =======================================*/


  const navigate = useNavigate();
  const defaultValues: any = {
    lang_id: lang_id ? lang_id : "null",
    lang: "",
    labels: null,
  };
  
  const [loading, setLoading] = useState(false); 
  const [formValues, setFormValues] = useState(defaultValues);
  const [labelsValues, setLabelsValues] = useState<Record<string, Record<string, string>>>({});


  const handleInputChange = (e: { target: { name: any; value: any; }; }) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  // Handler para cambios en los labels
  const handleLabelChange = (module: string, key: string, value: string) => {
    setLabelsValues(prev => ({
      ...prev,
      [module]: {
        ...prev[module],
        [key]: value
      }
    }));
  };


  const handleSubmit = () => {

    const dataToSend = {
      ...formValues,
      labels: applyCanonicalCommonLabels(labelsValues, formValues.lang_id || lang_id)
    };

    console.log("formValues", dataToSend)
    
    axios.post(ProjectConfig.api_url, null,
      {
        params: {
          request: 'add_edit_lang',
          formdata: dataToSend,
        }
      })
        .then((response) => {
          console.log(response); 
          if(response.data){
            enqueueSnackbar("Idioma guardado correctamente", { variant: 'success' });
            setLoading(true)
            navigate(-1)
          } else {
            enqueueSnackbar("Error al guardar el idioma. Puede que ya exista.", { variant: 'error' });
          }
           
        })
        .catch((err) => {
          console.log(err.data);
        })
        
  };



  /**/

  useEffect(() => {
    if (lang_id) {
      axios
        .get(ProjectConfig.api_url, {
          params: {
            request: "lang_details",
            lang_id: lang_id,
          },
        })
        .then((response) => {
          console.log("formValues", response.data)
          setFormValues(response.data);
          // Cargar labels existentes
          if (response.data.labels) {
            setLabelsValues(
              applyCanonicalCommonLabels(
                response.data.labels,
                response.data.lang_id || lang_id
              )
            );
          }
        })
        .catch((err) => {
          console.log(err.data);
        });
    }
  }, []);


  return (
      <div id="langForm">
        <div className="langForm_right">
          <Box id="lang_editor" className="box_editor" title="Idioma" subtitle="Editar">
            <div className='input_group'>
                <h2>Información del Idioma</h2>
                <div className='input_group'>
                    <TextField 
                      id="lang"
                      name="lang"
                      label="Idioma"
                      type="text"
                      required
                      fullWidth
                      value={formValues.lang}
                      onChange={handleInputChange}
                    />
                </div>
            </div>

            {/* Sección de Labels por módulo */}
            {lang_id && lang_id !== "null" && (
              <div className='input_group' style={{ marginTop: '30px' }}>
                {Object.entries(SYSTEM_LABELS).map(([moduleKey, moduleData]) => (
                  <div key={moduleKey} style={{ marginBottom: '30px' }}>
                    <Divider style={{ marginBottom: '20px' }} />
                    <Typography variant="h6" style={{ marginBottom: '15px', color: '#6e5002', fontWeight: 'bold' }}>
                      {moduleData.title}
                    </Typography>
                    
                    {moduleData.labels.map((label) => (
                      <div key={label.key} style={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        marginBottom: '15px',
                        gap: '20px'
                      }}>
                        <Typography style={{ 
                          minWidth: '200px', 
                          fontWeight: '500',
                          color: '#333'
                        }}>
                          {label.defaultValue}
                        </Typography>
                        <TextField
                          fullWidth
                          size="small"
                          placeholder={`Traducción de "${label.defaultValue}"`}
                          value={labelsValues[moduleKey]?.[label.key] || ''}
                          onChange={(e) => handleLabelChange(moduleKey, label.key, e.target.value)}
                        />
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            )}

            <div className='buttons'>
              <Button onClick={() => navigate(-1)} variant="outlined" className="button_2">Cancelar</Button>
              <Button onClick={handleSubmit} variant="contained" className="button_1">Guardar</Button>
            </div>
          </Box>
        </div>
      </div>
  );
  })
